/**
 * Stage 2.2 — the client user's work: what is waiting on me, what RM24 is
 * handling, and which objects I answer for. One callable, `getMyClientWork`,
 * read once per shell by `client/ClientWorkContext.tsx`.
 *
 * The contract is `GetMyClientWorkResult` in `shared-types/src/clientWork.ts`;
 * the aliases below keep the names the pages already use.
 */

import type {
  ClientCompanyOverviewSite,
  ClientWorkResponsibility,
  ClientWorkTaskV1,
  GetMyClientWorkResult,
} from '@rendimees24/shared-types';

import { httpsCallableWithLog as httpsCallable } from './errorLog';
import { getFirebase } from './firebase';

export type MyClientWork = GetMyClientWorkResult;
export type MyResponsibility = ClientWorkResponsibility;
/** @deprecated v1 task line — screens read `attention`. */
export type MyTask = ClientWorkTaskV1;
export type CompanyOverviewSite = ClientCompanyOverviewSite;

export async function getMyClientWork(clientId: string): Promise<MyClientWork> {
  const { functions } = getFirebase();
  const callable = httpsCallable<{ clientId: string }, MyClientWork>(functions, 'getMyClientWork');
  const { data } = await callable({ clientId });
  return data;
}
